
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
} from "react-router-dom";
import "./App.css";
import Home from "./Home";
import Movie from "./Movie";
import Animation from "./Animation";
import Comedy from "./Comedy";
import Action from "./Action";
import Documentry from "./Documentry";
import Adventure from "./Adventure";
import Search from "./Search";
import Navbar from "./Navbar";
import Footer from "./Footer";

// 435c8880fa41fdbe5fba133c47f78d2b  

// const getTrailer = (path) => `http://api.themoviedb.org/3/movie/${path}/videos?api_key=8b62f4bda40c67dbe48ddb6db1f858dc`
function App() {


  return (

    <Router>
      <Navbar />
     
    <Switch> 
    <Route path="/Action">
        <Action />
        </Route>
       
          
    <Route path="/animation">
        <Animation />
      </Route>
        <Route path="/Adventure">
        <Adventure />
      </Route>
      <Route path="/Search">
        <Search />
      </Route>
      <Route path="/Comedy">
        <Comedy />
      </Route>
      <Route exact  path="/Documentry">
        <Documentry />
        </Route>
      <Route path="/movie/:id">
        <Movie />
      </Route>
      <Route exact path="/animation" component={Animation} />
      <Route path="/">
        <Home />
      </Route>
      
     
      
    </Switch>
    <Footer />

  </Router>





    

    
  );
}

export default App;
